import { inject, Injectable, InjectionToken } from '@angular/core';

const SpecialValues = {
  0: '',
  1: 'lightning',
  2: 'warning',
  3: 'fog',
  4: 'wind',
  5: 'flood',
};

const UniValues = {
  1: 'sun',
  2: 'moon',
  3: '',
};

export const ForecastIconAssetsPath = new InjectionToken('forecastIconAssetsPath');

@Injectable()
export class WeatherForecastService {
  private readonly forecastIconAssetsPath = inject(ForecastIconAssetsPath, { optional: true });

  getIconSvg(weatheSymbolDay: string) {
    let icon = '';
    const uni = UniValues[parseInt(weatheSymbolDay[0])];
    icon += uni;

    const cloud = this.getIconValue('cloud', parseInt(weatheSymbolDay[1]));
    icon += icon !== '' && cloud !== '' ? `+${cloud}` : cloud;

    const rain = this.getIconValue('rain', parseInt(weatheSymbolDay[2]));
    icon += icon !== '' && rain !== '' ? `+${rain}` : rain;

    const snow = this.getIconValue('snow', parseInt(weatheSymbolDay[3]));
    icon += icon !== '' && snow !== '' ? `+${snow}` : snow;

    const hail = this.getIconValue('hail', parseInt(weatheSymbolDay[4]));
    icon += icon !== '' && hail !== '' ? `+${hail}` : hail;

    const special = SpecialValues[parseInt(weatheSymbolDay[5])];
    icon += icon !== '' && special !== '' ? `+${special}` : special;

    // particular cases
    // 1- To handle the case we have this kind of icon: sun+2-cloud+1-rain+lightning
    // we ignore the third part => 1-rain so it'll become => sun+2-cloud+lightning
    if (icon.includes('+lightning')) {
      const iconParts = icon.split('+');
      if (iconParts.length === 4) {
        icon = `${iconParts[0]}+${iconParts[1]}+${iconParts[3]}`;
      } else {
        icon = uni;
        icon += icon !== '' && cloud !== '' ? `+${cloud}` : cloud;
        icon += '+lightning';
      }
    }
    // 2- To handle the case we have this kind of icon: [1-3]-cloud\+[1-3]-rain\+[1-3]-snow
    // we ignore the second part => [1-3]-rain so it'll become => [1-3]-cloud\+[1-3]-snow
    else if (/^[1-3]-cloud\+[1-3]-rain\+[1-3]-snow$/.test(icon)) {
      const iconParts = icon.split('+');
      icon = `${iconParts[0]}+${iconParts[2]}`;
    }
    const assetsPath = this.forecastIconAssetsPath || '/assets/weather-forecast-icons';
    return `${assetsPath}/${icon}.svg`;
  }

  private getIconValue(type: string, value: number) {
    if (value === 0) return '';
    return `${value}-${type}`;
  }
}
